










import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import UrlMixin from '../../../mixins/url';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';

import Item from '@/components/Molecules/Breadcrumbs/Item.vue';

@Component({
  components: {
    UnorderedList,
    Item,
  },
})
export default class Hikari extends mixins(UrlMixin) {
  @Prop({ default: '2分でかんたん！Webでお見積り書作成' })
  readonly pageTitle!: string;
}
